var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00018 7.99992C2.23383 8.00038 2.46027 7.919 2.64018 7.76992L8.00018 3.28992L13.3702 7.60992C13.4725 7.69298 13.5902 7.75502 13.7165 7.79245C13.8428 7.82988 13.9753 7.84197 14.1064 7.82803C14.2374 7.8141 14.3644 7.7744 14.48 7.71122C14.5956 7.64805 14.6977 7.56265 14.7802 7.45992C14.8632 7.35763 14.9253 7.23994 14.9627 7.1136C15.0001 6.98726 15.0122 6.85477 14.9983 6.72374C14.9844 6.59271 14.9447 6.46573 14.8815 6.35009C14.8183 6.23445 14.7329 6.13244 14.6302 6.04992L8.63018 1.21992C8.45125 1.07284 8.2268 0.992432 7.99518 0.992432C7.76355 0.992432 7.53911 1.07284 7.36018 1.21992L1.36018 6.21992C1.25892 6.30387 1.17522 6.40697 1.11387 6.52332C1.05252 6.63966 1.01472 6.76697 1.00264 6.89795C0.990567 7.02893 1.00445 7.161 1.04349 7.2866C1.08254 7.41221 1.14598 7.52887 1.23018 7.62992C1.32323 7.74463 1.44054 7.83731 1.57368 7.90128C1.70682 7.96526 1.85247 7.99894 2.00018 7.99992Z",
    fill: "#96A0AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.3370912d325fe5dc359db4e9275b8d5c.svg";
export { ForwardRef as ReactComponent };